"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import { extractProperty } from "utils"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

type Props = {
  data: any
  blockIndex?: number
  isHomepage?: boolean
  isSmartBlockRenderer?: boolean
}

const MainTitle = ({
  data,
  blockIndex,
  isHomepage,
  isSmartBlockRenderer,
}: Props) => {
  const title = extractProperty(data, "title")
  const isGray =
    isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1

  const content = (
    <OuterContainer $isGray={isGray}>
      <Typography variant="h2" component={"h1"}>
        {title}
      </Typography>
    </OuterContainer>
  )

  if (isSmartBlockRenderer) {
    return <Container paddingMobile>{content}</Container>
  }

  return content
}

export default MainTitle
